export default function WebchatEmptyStateWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={`relative flex h-[600px] max-h-[675px] w-full min-w-[324px] flex-col gap-3 pt-6 sm:gap-4 md:h-[675px]
      lg:w-[400px] lg:px-5`}
    >
      {children}
    </div>
  )
}
